import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6ffde680 from 'nuxt_plugin_plugin_6ffde680' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_7bc03ccc from 'nuxt_plugin_sentryserver_7bc03ccc' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_5c667012 from 'nuxt_plugin_sentryclient_5c667012' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_7a2b8b7e from 'nuxt_plugin_cookieuniversalnuxt_7a2b8b7e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_565c05b6 from 'nuxt_plugin_pluginutils_565c05b6' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_c37055a0 from 'nuxt_plugin_pluginrouting_c37055a0' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5836b782 from 'nuxt_plugin_pluginmain_5836b782' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_nuxtsmartlink35e22752_20547ee8 from 'nuxt_plugin_nuxtsmartlink35e22752_20547ee8' // Source: ./nuxt.smart-link.35e22752.js (mode: 'all')
import nuxt_plugin_nuxtdirective25d0da2c_89816436 from 'nuxt_plugin_nuxtdirective25d0da2c_89816436' // Source: ./nuxt.directive.25d0da2c.js (mode: 'client')
import nuxt_plugin_nuxtsettings65f419dc_299c11e4 from 'nuxt_plugin_nuxtsettings65f419dc_299c11e4' // Source: ./nuxt.settings.65f419dc.js (mode: 'all')
import nuxt_plugin_nuxtpagetransitionandanchorhandler_d326cec0 from 'nuxt_plugin_nuxtpagetransitionandanchorhandler_d326cec0' // Source: ./nuxt-page-transition-and-anchor-handler.js (mode: 'client')
import nuxt_plugin_nuxtpagetransitionandanchorhandlernoops_04f9ab3b from 'nuxt_plugin_nuxtpagetransitionandanchorhandlernoops_04f9ab3b' // Source: ./nuxt-page-transition-and-anchor-handler-no-ops.js (mode: 'server')
import nuxt_plugin_workbox_a04ba11c from 'nuxt_plugin_workbox_a04ba11c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_e3e436f6 from 'nuxt_plugin_metaplugin_e3e436f6' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_da94ec0e from 'nuxt_plugin_iconplugin_da94ec0e' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_objectFitPolyfill_d5b9c83e from 'nuxt_plugin_objectFitPolyfill_d5b9c83e' // Source: ./nuxt-polyfill/objectFitPolyfill.js (mode: 'all')
import nuxt_plugin_gtm_50fdc7a8 from 'nuxt_plugin_gtm_50fdc7a8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginscraft196fc82a_0a5988ea from 'nuxt_plugin_pluginscraft196fc82a_0a5988ea' // Source: ./plugins.craft.196fc82a.js (mode: 'all')
import nuxt_plugin_axios_5cc057d6 from 'nuxt_plugin_axios_5cc057d6' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtplugin2a3224fe_cc37f23a from 'nuxt_plugin_nuxtplugin2a3224fe_cc37f23a' // Source: ./nuxt.plugin.2a3224fe.js (mode: 'client')
import nuxt_plugin_nuxtplugin20f0a38a_43bb210f from 'nuxt_plugin_nuxtplugin20f0a38a_43bb210f' // Source: ./nuxt.plugin.20f0a38a.js (mode: 'all')
import nuxt_plugin_helpers_5f1c6bd2 from 'nuxt_plugin_helpers_5f1c6bd2' // Source: ../../@bkwld/cloak/plugins/helpers (mode: 'all')
import nuxt_plugin_focusvisible_b1032fec from 'nuxt_plugin_focusvisible_b1032fec' // Source: ../../@bkwld/cloak/plugins/focus-visible (mode: 'all')
import nuxt_plugin_services_bc71243a from 'nuxt_plugin_services_bc71243a' // Source: ../../../plugins/services (mode: 'all')
import nuxt_plugin_clientglobals_47b5b2f3 from 'nuxt_plugin_clientglobals_47b5b2f3' // Source: ../../../plugins/client-globals (mode: 'client')
import nuxt_plugin_onetrust_6fd80592 from 'nuxt_plugin_onetrust_6fd80592' // Source: ../../../plugins/onetrust (mode: 'client')
import nuxt_plugin_lenissmoothscroller_f63baf74 from 'nuxt_plugin_lenissmoothscroller_f63baf74' // Source: ../../../plugins/lenis-smooth-scroller (mode: 'client')
import nuxt_plugin_smoothscrollerssr_601d4119 from 'nuxt_plugin_smoothscrollerssr_601d4119' // Source: ../../../plugins/smooth-scroller-ssr (mode: 'server')
import nuxt_plugin_measureviewport_446208ba from 'nuxt_plugin_measureviewport_446208ba' // Source: ../../../plugins/measure-viewport (mode: 'client')
import nuxt_plugin_plugin_13e38940 from 'nuxt_plugin_plugin_13e38940' // Source: ../../nuxt-spa-store-init/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"ptah","mode":"","beforeLeave":function() { this.$beforePageLeave() },"afterEnter":function() { this.$afterPageEnter() }}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"msapplication-tap-highlight","content":"no"},{"name":"viewport","content":"width=device-width, height=device-height, initial-scale=1, minimal-ui, viewport-fit=cover"}],"script":[{"hid":"polyfill","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fpolyfill\u002Fv3\u002Fpolyfill.min.js?version=4.8.0&features=default%2CURL%2CNodeList.prototype.forEach%2CIntersectionObserver%2CElement.prototype.remove%2CObject.values","body":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T2J9QMD')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"titleTemplate":function(title) {
          if (title && title !== process.env.SITE_NAME) {
            return `${title} | ${process.env.SITE_NAME}`;
          } else {
            return process.env.SITE_NAME;
          }
        },"link":[],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T2J9QMD&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6ffde680 === 'function') {
    await nuxt_plugin_plugin_6ffde680(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_7bc03ccc === 'function') {
    await nuxt_plugin_sentryserver_7bc03ccc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_5c667012 === 'function') {
    await nuxt_plugin_sentryclient_5c667012(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7a2b8b7e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7a2b8b7e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_565c05b6 === 'function') {
    await nuxt_plugin_pluginutils_565c05b6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_c37055a0 === 'function') {
    await nuxt_plugin_pluginrouting_c37055a0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_5836b782 === 'function') {
    await nuxt_plugin_pluginmain_5836b782(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsmartlink35e22752_20547ee8 === 'function') {
    await nuxt_plugin_nuxtsmartlink35e22752_20547ee8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtdirective25d0da2c_89816436 === 'function') {
    await nuxt_plugin_nuxtdirective25d0da2c_89816436(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsettings65f419dc_299c11e4 === 'function') {
    await nuxt_plugin_nuxtsettings65f419dc_299c11e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtpagetransitionandanchorhandler_d326cec0 === 'function') {
    await nuxt_plugin_nuxtpagetransitionandanchorhandler_d326cec0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtpagetransitionandanchorhandlernoops_04f9ab3b === 'function') {
    await nuxt_plugin_nuxtpagetransitionandanchorhandlernoops_04f9ab3b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_a04ba11c === 'function') {
    await nuxt_plugin_workbox_a04ba11c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_e3e436f6 === 'function') {
    await nuxt_plugin_metaplugin_e3e436f6(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_da94ec0e === 'function') {
    await nuxt_plugin_iconplugin_da94ec0e(app.context, inject)
  }

  if (typeof nuxt_plugin_objectFitPolyfill_d5b9c83e === 'function') {
    await nuxt_plugin_objectFitPolyfill_d5b9c83e(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_50fdc7a8 === 'function') {
    await nuxt_plugin_gtm_50fdc7a8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscraft196fc82a_0a5988ea === 'function') {
    await nuxt_plugin_pluginscraft196fc82a_0a5988ea(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5cc057d6 === 'function') {
    await nuxt_plugin_axios_5cc057d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtplugin2a3224fe_cc37f23a === 'function') {
    await nuxt_plugin_nuxtplugin2a3224fe_cc37f23a(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin20f0a38a_43bb210f === 'function') {
    await nuxt_plugin_nuxtplugin20f0a38a_43bb210f(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_5f1c6bd2 === 'function') {
    await nuxt_plugin_helpers_5f1c6bd2(app.context, inject)
  }

  if (typeof nuxt_plugin_focusvisible_b1032fec === 'function') {
    await nuxt_plugin_focusvisible_b1032fec(app.context, inject)
  }

  if (typeof nuxt_plugin_services_bc71243a === 'function') {
    await nuxt_plugin_services_bc71243a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientglobals_47b5b2f3 === 'function') {
    await nuxt_plugin_clientglobals_47b5b2f3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onetrust_6fd80592 === 'function') {
    await nuxt_plugin_onetrust_6fd80592(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lenissmoothscroller_f63baf74 === 'function') {
    await nuxt_plugin_lenissmoothscroller_f63baf74(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_smoothscrollerssr_601d4119 === 'function') {
    await nuxt_plugin_smoothscrollerssr_601d4119(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_measureviewport_446208ba === 'function') {
    await nuxt_plugin_measureviewport_446208ba(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_13e38940 === 'function') {
    await nuxt_plugin_plugin_13e38940(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
